module.exports = __webpack_public_path__ + "static/financial-services-sectors-326f53e2f31e3ab06992659ec6bffe7d.jpg";